var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMascotTronDaoBotAdaptive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mascot-Tron-dao-adaptive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mascot-Tron-dao-bg-adaptive",
    filter: "url(#filter0_f_1877_17777)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.141,
    cy: 48.3433,
    r: 34.4859,
    transform: "rotate(-2 51.141 48.3433)",
    fill: "#EC0828",
    fillOpacity: 0.61
  })), /*#__PURE__*/React.createElement("g", {
    id: "mascot-Tron-dao-icon-adaptive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3194 35.1574C16.3807 29.1213 20.764 24.2513 23.0189 22.0326C29.6792 16.9513 33.2866 16.3036 37.8367 15.4865L37.9262 15.4705C45.0123 14.1978 60.7308 13.7433 67.321 15.4497C75.5587 17.5827 80.3866 22.2554 83.3158 27.2049C86.2451 32.1544 89.7006 40.0324 88.2467 56.0805C87.0836 68.9189 80.4909 73.8221 74.8833 77.1753L65.6281 82.3398L54.4746 87.781C49.1056 85.8285 36.3162 80.8585 28.1102 76.5985C17.8528 71.2734 15.5908 61.1436 14.9733 58.6392C13.661 53.3175 14.1753 41.6652 15.3194 35.1574Z",
    fill: "url(#paint0_linear_1877_17777)",
    stroke: "black",
    strokeWidth: 0.428323
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.9391 58.0323L15.4336 58.5039L15.8062 60.0976L16.2917 61.9017L16.992 63.8053L17.9071 65.8086C23.5655 65.6967 27.9646 65.4216 28.5526 65.1155C29.5991 63.6221 29.2011 59.4871 28.9391 58.0323Z",
    stroke: "black",
    strokeWidth: 0.428323
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.9919 32.8543C30.7144 27.8205 24.048 24.6917 21.4804 23.9702C28.083 15.9616 36.6546 15.2334 45.0461 14.5205L45.2281 14.505C52.092 13.9216 64.8516 13.9134 71.472 16.7626C79.4305 20.1877 84.0009 26.6934 86.2288 32.8577C88.4568 39.0221 89.2527 49.68 88.5945 55.0987C87.815 61.5154 86.3243 71.8581 77.522 74.7407C67.7818 77.9304 55.2639 77.4153 44.7048 75.3577C35.3648 73.5376 34.0108 63.362 33.4362 59.0434L33.436 59.042C32.8615 54.7243 33.5887 39.1465 31.9919 32.8543Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.428323
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 58.9844,
    y: 63.4336,
    width: 9.9921,
    height: 2.57861,
    rx: 1.2893,
    transform: "rotate(-2 58.9844 63.4336)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.7977 61.1974C42.2224 57.7038 36.2107 57.5511 33.4759 57.9666C34.0085 64.1338 34.5388 67.2082 37.4187 70.9471C39.7069 73.9176 43.282 75.3284 46.9934 75.6254L46.6884 66.8905C46.5656 63.3753 45.3567 62.0666 44.7977 61.1974Z",
    stroke: "black",
    strokeWidth: 0.428323
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.567 33.9827C27.3533 32.3166 23.1299 30.1563 20.8423 29.1272L18.6711 35.677C20.3121 35.8355 26.1555 38.7425 29.0832 43.6755L30.0272 37.6182C29.9544 37.2311 29.6804 35.5111 28.567 33.9827Z",
    fill: "#CAA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.2243 74.5543L18.4453 66.3008L19.0755 67.3741L19.7933 68.5286C20.7402 69.8364 22.189 71.8539 24.5049 73.6721C26.3581 75.127 27.8387 76.0648 31.4983 77.6354L35.927 79.72L46.8906 79.6597L59.1456 79.6349L69.465 79.5971L76.1088 75.8979L76.8139 75.3089C68.6144 77.8451 53.4144 77.4794 44.6273 76.1772L32.2243 74.5543Z",
    fill: "#7057F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.9003 81.1611L47.5378 80.9293L52.5103 85.7547L40.9003 81.1611Z",
    fill: "#383740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.6192 59.6906L17.418 60.0469L18.3103 62.5099L27.4407 62.2771C27.851 61.7123 27.8201 60.3143 27.6192 59.6906Z",
    fill: "#826CF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M42.3576 81.4297L49.369 81.1848L54.6287 86.484L42.3576 81.4297Z",
    fill: "#634AE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M35.0547 80.0742L70.3661 79.9361L66.7385 82.0337L65.4941 82.7342L64.6645 83.2012L54.4792 88.2653L49.443 86.3607L44.3992 84.2373L35.0547 80.0742Z",
    fill: "#7057F0",
    stroke: "black",
    strokeWidth: 0.428323
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M40.9078 81.4812L48.929 81.2011L53.9842 86.5075L40.9078 81.4812Z",
    fill: "#644AE7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 35.3516,
    y: 37.8125,
    width: 24.0133,
    height: 15.794,
    rx: 2.14161,
    transform: "rotate(-2 35.3516 37.8125)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter1_f_1877_17777)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.3934,
    cy: 45.0493,
    rx: 9.93914,
    ry: 6.13815,
    transform: "rotate(-2 47.3934 45.0493)",
    fill: "#A00C36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    filter: "url(#filter2_f_1877_17777)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.2845,
    cy: 45.4093,
    rx: 6.36594,
    ry: 4.27082,
    transform: "rotate(-2 47.2845 45.4093)",
    fill: "#EC0828"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 61.4414,
    y: 36.9023,
    width: 24.0133,
    height: 15.794,
    rx: 2.14161,
    transform: "rotate(-2 61.4414 36.9023)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    filter: "url(#filter3_f_1877_17777)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.6691,
    cy: 44.4666,
    rx: 10.1798,
    ry: 6.13815,
    transform: "rotate(-2 73.6691 44.4666)",
    fill: "#A00C36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    filter: "url(#filter4_f_1877_17777)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.8861,
    cy: 44.6086,
    rx: 6.36594,
    ry: 4.27082,
    transform: "rotate(-2 73.8861 44.6086)",
    fill: "#EC0828"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M46.796 51.9724C46.7506 51.8887 46.7126 51.8306 46.6848 51.7674C46.2858 50.8492 45.8878 49.9304 45.4906 49.011C44.7111 47.2139 43.9315 45.4177 43.152 43.6222C42.484 42.0801 41.8166 40.5379 41.1497 38.9958C41.145 38.9872 41.1408 38.9783 41.1372 38.9691C41.1121 38.8841 41.0876 38.7985 41.0626 38.7129C41.147 38.7057 41.232 38.7053 41.3165 38.7117C42.1158 38.8308 42.9135 38.9553 43.7122 39.0757C44.6061 39.2098 45.5011 39.3397 46.395 39.4737C46.974 39.5606 47.5515 39.6545 48.1299 39.7414C48.8042 39.8437 49.4789 39.9413 50.1532 40.0419C50.4594 40.09 50.7655 40.134 51.0701 40.1863C51.1308 40.1994 51.1872 40.2282 51.2335 40.2701C52.0757 41.0218 52.9171 41.7746 53.7575 42.5283C53.8355 42.5985 53.8391 42.6525 53.7747 42.7377C52.1277 44.9187 50.482 47.1006 48.8375 49.2835C48.2009 50.1292 47.5627 50.9719 46.9229 51.8115C46.8925 51.8561 46.8562 51.8997 46.796 51.9724ZM46.6468 49.8312L46.6871 49.8198C46.6964 49.7938 46.7033 49.7669 46.7076 49.7396C46.7747 48.955 46.8417 48.1703 46.9084 47.3856C47.001 46.2742 47.0935 45.1633 47.1791 44.0516C47.1786 44.0148 47.1708 43.9786 47.156 43.945C47.1413 43.9114 47.1199 43.8812 47.0932 43.8563C46.9134 43.7002 46.7219 43.5587 46.5343 43.4117C45.2476 42.4065 43.9608 41.4018 42.6738 40.3978C42.6416 40.3751 42.608 40.3542 42.5734 40.3354L42.5412 40.3624L46.6468 49.8312ZM52.4541 43.2691C52.3921 43.2668 52.33 43.269 52.2684 43.2756C51.7959 43.3786 51.3242 43.485 50.8518 43.5886L49.1088 43.9706C48.7592 44.047 48.4097 44.1256 48.0596 44.2002C47.9557 44.2221 47.8994 44.2734 47.8917 44.3861C47.8838 44.5422 47.8666 44.6981 47.8534 44.8545C47.7938 45.5565 47.7339 46.2584 47.6735 46.9601C47.6078 47.7404 47.5424 48.5205 47.4774 49.3004C47.4627 49.4774 47.4532 49.6542 47.4413 49.8311L47.4832 49.8484L52.4541 43.2691ZM50.1763 40.8528L50.1397 40.7882L43.098 39.7295L43.07 39.7763C43.1123 39.806 43.1551 39.8322 43.1964 39.8666C43.5644 40.1526 43.9322 40.4393 44.2999 40.7269C45.3157 41.5202 46.3314 42.3118 47.3398 43.1113C47.4713 43.2155 47.5516 43.2033 47.6693 43.095C48.4544 42.3759 49.2467 41.6635 50.0355 40.9495C50.0802 40.9141 50.1272 40.8818 50.1763 40.8528ZM52.5386 42.4585C52.5205 42.4278 52.5001 42.3987 52.4774 42.3713C52.019 41.9591 51.5582 41.5475 51.1003 41.1341C51.0301 41.0713 50.9823 41.0847 50.9159 41.1452C50.3046 41.7001 49.6904 42.2515 49.0779 42.8053C48.8999 42.9662 48.7243 43.1306 48.5475 43.2944L48.5657 43.3308L52.5386 42.4585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M73.8077 51.031C73.7624 50.9473 73.7243 50.8892 73.6965 50.826C73.2975 49.9078 72.8995 48.989 72.5024 48.0696C71.7228 46.2725 70.9432 44.4763 70.1637 42.6808C69.4957 41.1387 68.8283 39.5965 68.1615 38.0544C68.1567 38.0458 68.1525 38.0369 68.1489 38.0277C68.1239 37.9427 68.0994 37.8571 68.0743 37.7715C68.1588 37.7643 68.2437 37.7639 68.3282 37.7703C69.1275 37.8894 69.9252 38.0139 70.7239 38.1343C71.6178 38.2683 72.5128 38.3983 73.4067 38.5323C73.9857 38.6192 74.5632 38.7131 75.1417 38.8C75.816 38.9023 76.4907 38.9999 77.1649 39.1005C77.4711 39.1486 77.7772 39.1926 78.0818 39.2449C78.1426 39.2579 78.1989 39.2868 78.2452 39.3287C79.0874 40.0804 79.9288 40.8332 80.7692 41.5869C80.8472 41.6571 80.8508 41.7111 80.7864 41.7963C79.1395 43.9773 77.4937 46.1592 75.8492 48.3421C75.2126 49.1878 74.5745 50.0305 73.9346 50.8701C73.9042 50.9147 73.8679 50.9583 73.8077 51.031ZM73.6586 48.8898L73.6988 48.8784C73.7081 48.8524 73.715 48.8255 73.7193 48.7982C73.7864 48.0136 73.8534 47.2289 73.9201 46.4442C74.0127 45.3328 74.1052 44.2219 74.1908 43.1101C74.1904 43.0734 74.1825 43.0371 74.1678 43.0036C74.153 42.97 74.1316 42.9398 74.1049 42.9149C73.9251 42.7588 73.7336 42.6173 73.546 42.4703C72.2593 41.4651 70.9725 40.4604 69.6855 39.4564C69.6533 39.4337 69.6197 39.4128 69.5851 39.394L69.5529 39.421L73.6586 48.8898ZM79.4658 42.3277C79.4038 42.3254 79.3418 42.3276 79.2801 42.3342C78.8077 42.4372 78.3359 42.5436 77.8636 42.6472L76.1205 43.0292C75.7709 43.1056 75.4215 43.1842 75.0713 43.2588C74.9674 43.2807 74.9111 43.332 74.9034 43.4447C74.8955 43.6008 74.8783 43.7567 74.8651 43.913C74.8056 44.6151 74.7456 45.317 74.6853 46.0187C74.6195 46.799 74.5541 47.5791 74.4892 48.359C74.4744 48.536 74.4649 48.7128 74.4531 48.8897L74.4949 48.907L79.4658 42.3277ZM77.188 39.9114L77.1514 39.8468L70.1097 38.7881L70.0817 38.8349C70.124 38.8646 70.1668 38.8908 70.2081 38.9252C70.5761 39.2112 70.9439 39.4979 71.3116 39.7855C72.3274 40.5788 73.3431 41.3704 74.3515 42.1698C74.483 42.2741 74.5634 42.2619 74.6811 42.1536C75.4661 41.4345 76.2584 40.7221 77.0472 40.0081C77.0919 39.9727 77.139 39.9404 77.188 39.9114ZM79.5503 41.5171C79.5322 41.4864 79.5118 41.4573 79.4891 41.4299C79.0307 41.0176 78.5699 40.6061 78.112 40.1927C78.0418 40.1298 77.9941 40.1433 77.9276 40.2038C77.3164 40.7587 76.7021 41.3101 76.0897 41.8639C75.9116 42.0248 75.736 42.1891 75.5592 42.353L75.5774 42.3894L79.5503 41.5171Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_17777",
    x: 4.30627,
    y: 1.50549,
    width: 93.6726,
    height: 93.6726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.17499,
    result: "effect1_foregroundBlur_1877_17777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_17777",
    x: 35.3154,
    y: 36.7646,
    width: 24.1543,
    height: 16.5723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07081,
    result: "effect1_foregroundBlur_1877_17777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1877_17777",
    x: 39.4227,
    y: 39.6376,
    width: 15.7248,
    height: 11.5451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.749565,
    result: "effect1_foregroundBlur_1877_17777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1877_17777",
    x: 61.3506,
    y: 36.1787,
    width: 24.6348,
    height: 16.5762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07081,
    result: "effect1_foregroundBlur_1877_17777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1877_17777",
    x: 66.0243,
    y: 38.8368,
    width: 15.7248,
    height: 11.5451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.749565,
    result: "effect1_foregroundBlur_1877_17777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_17777",
    x1: 21.0401,
    y1: 25.1698,
    x2: 44.0942,
    y2: 88.1502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotTronDaoBotAdaptive);
export default __webpack_public_path__ + "static/media/MascotTronDaoBotAdaptive.8732edc6b383fa8e5d5da4b8075349e8.svg";
export { ForwardRef as ReactComponent };